import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { HistoricoManutencao } from '../../types/manutencao';
import { historicoManutencaoService } from '../../services';

const fields: ResourceField<HistoricoManutencao>[] = [
  { name: 'ordem', label: 'Ordem (ID)', type: 'number' },
  { name: 'maquina', label: 'Máquina (ID)', type: 'number' },
  { name: 'tipo_evento', label: 'Tipo de evento', type: 'select', options: [{ label: 'Início', value: 'INICIO' }, { label: 'Pausa', value: 'PAUSA' }, { label: 'Retomada', value: 'RETOMADA' }, { label: 'Conclusão', value: 'CONCLUSAO' }, { label: 'Observação', value: 'OBSERVACAO' }] },
  { name: 'operador_responsavel', label: 'Responsável' },
  { name: 'observacoes', label: 'Observações', type: 'textarea' }
];

export const HistoricoManutencaoFormPage: React.FC = () => (
  <ResourceFormPage
    title="Evento de manutenção"
    description="Registre os eventos ocorridos em uma ordem."
    fields={fields}
    service={ historicoManutencaoService }
    redirectPath="/admin/manutencao/historico-manutencao"
    cancelPath="/admin/manutencao/historico-manutencao"
  />
);
